import { useEffect, useState } from "react";
import axios from "axios";
import { Hourglass } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const pad = (n) => String(n).padStart(2, "0");

export const PromoBanner = ({ onBegin }) => {
    const [promo, setPromo] = useState(null);
    const [left, setLeft] = useState(0);

    useEffect(() => {
        axios.get(`${API}/promo`).then((r) => setPromo(r.data)).catch(() => {});
    }, []);

    useEffect(() => {
        if (!promo?.active) return;
        const tick = () => setLeft(Math.max(0, new Date(promo.until).getTime() - Date.now()));
        tick();
        const t = setInterval(tick, 1000);
        return () => clearInterval(t);
    }, [promo]);

    if (!promo?.active) return null;

    const h = Math.floor(left / 3600000);
    const m = Math.floor(left / 60000) % 60;
    const s = Math.floor(left / 1000) % 60;

    return (
        <div
            data-testid="promo-banner-strip"
            className="relative z-40 border-b border-[#ffd700]/25 bg-[#2a1a05]/40 backdrop-blur-xl"
        >
            <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-1 px-5 pb-2.5 pt-[4.8rem] text-center">
                <Hourglass className="h-3.5 w-3.5 animate-pulse-soft text-[#ffd700]/80" />
                <span className="font-cinzel text-[11px] tracking-[0.25em] text-[#ffd700]/90">
                    FOR 24 HOURS, EVERY READING IS FREE
                </span>
                <span className="hidden font-cormorant text-sm italic text-[#e0aaff]/80 sm:inline">
                    five minutes with Mara, no more
                </span>
                <span data-testid="promo-banner-timer" className="font-mono text-xs tracking-widest text-[#f8f7ff]">
                    {pad(h)}:{pad(m)}:{pad(s)}
                </span>
                <a
                    href="#readings"
                    data-testid="promo-banner-cta"
                    className="font-cinzel text-[10px] tracking-[0.2em] text-[#f8f7ff] underline decoration-[#ffd700]/50 underline-offset-4 transition-colors duration-300 hover:text-[#ffd700]"
                >
                    CLAIM YOURS
                </a>
            </div>
        </div>
    );
};
